var map = {
	"./logo_demo.png": [
		52025,
		25
	],
	"./logo_excellus.png": [
		31937,
		937
	],
	"./logo_localhost.png": [
		33426,
		426
	],
	"./logo_sutherland.png": [
		49302
	],
	"./logo_wellmark.png": [
		88255,
		255
	],
	"./logo_zignaai.png": [
		76885
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 13784;
module.exports = webpackAsyncContext;